import { Button } from "../components/Button";

function copyToClipboard(text) {
  if (!text) return;
  const done = () => {
    const tg = window.Telegram?.WebApp;
    if (tg?.showAlert) tg.showAlert("Скопировано в буфер обмена");
  };
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(done).catch(() => {});
    return;
  }
  done();
}

export function Developers({ onBack }) {
  return (
    <section className="client">
      <header className="sectionHeader">
        <h2>О разработчиках</h2>
        <p>Контакты команды, которая сделала миниапп.</p>
      </header>

      <div className="eventsToolbar">
        <Button onClick={onBack}>Назад</Button>
      </div>

      <article className="homeSurface developersCard">
        <h3 className="developersCard__title">Код</h3>
        <p className="developersCard__name">ProDG</p>
        <ul className="developersCard__list">
          <li>
            Telegram:{" "}
            <a href="https://t.me/ProDG_Coder" target="_blank" rel="noopener noreferrer">
              @ProDG_Coder
            </a>
          </li>
          <li>
            Почта: <span className="developersCard__plain">isayeu@gmail.com</span>{" "}
            <button
              type="button"
              className="developersCard__copyBtn"
              onClick={() => copyToClipboard("isayeu@gmail.com")}
            >
              Скопировать
            </button>
          </li>
        </ul>
      </article>

      <article className="homeSurface developersCard">
        <h3 className="developersCard__title">Дизайн</h3>
        <p className="developersCard__name">Парфенова Ксения</p>
        <ul className="developersCard__list">
          <li>
            Telegram:{" "}
            <a href="https://t.me/ksumoikanal" target="_blank" rel="noopener noreferrer">
              @ksumoikanal
            </a>
          </li>
          <li>
            Телефон: <a href="tel:+79027641297">+7 902 764-12-97</a>
          </li>
          <li>
            Почта: <span className="developersCard__plain">parfenovaksenia3@yandex.ru</span>{" "}
            <button
              type="button"
              className="developersCard__copyBtn"
              onClick={() => copyToClipboard("parfenovaksenia3@yandex.ru")}
            >
              Скопировать
            </button>
          </li>
         
        </ul>
      </article>
    </section>
  );
}
